/** Values of the `receivings.STATUS` column, in the order of the receiving lifecycle. */
export const ReceivingStatuses = ['awaiting', 'unloaded', 'received', 'confirmed', 'canceled'];
